import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import reducers from './reducers';
import thunk from "redux-thunk";

const middleware = [applyMiddleware(thunk)];
if(window.__REDUX_DEVTOOLS_EXTENSION__) middleware.push(window.__REDUX_DEVTOOLS_EXTENSION__());

const store = createStore(reducers, compose(...middleware));

export default store;